export enum UserRole {
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  ACCOUNT_MANAGER = "ACCOUNT_MANAGER",
  TENANT_ADMIN = "TENANT_ADMIN",
  TENANT_STAFF = "TENANT_STAFF",
}